import React, { Fragment } from 'react';
import { Badge, Button, Card, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { ArcaHttpClientGroup } from '../../../code/ArcaHttpClientGroup';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaHttpWalkplan } from '../../../code/ArcaHttpWalkplan';
import { ArcaPlan } from '../../../code/Types/ArcaPlan';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { StatusBar } from '../StatusBar';
import { WalkSlot } from './WalkSlot';

export class PlanningFullPage extends ArcaComponent {
    constructor(props) {
        super(props);
        this.state = {
            plan: null,
            groups: null,
            showAssignPopup: false,
            unmatchedRequest: null,
            isError: false,
            statusText: '',
            showAlternatives: false
        };
    }

    async componentWillReceiveProps(newProps) {
        if (newProps === undefined)
            return;

        this.setState({ plan: newProps.plan })
    }

    getScreenDetails() {
        ArcaHttpClientGroup.GetGroupsAsync(
            ((groups) => this.setState({ groups, showAssignPopup: false })),
            ((err) => this.setState({ isError: true, statusText: err }))
        )
    }

    render() {
        let { plan, statusText, isError, groups, unmatchedRequest, windowWidth } = this.state;
        let width = '100%'

        let matchedGroups =
            groups?.filter(x => this.sessionsMatch(x.Session, unmatchedRequest?.Session) 
                && x.ActivityType === unmatchedRequest?.ActivityType)

        const plannedCard = <Card>
            <h1>Planned groups</h1>
            {plan?.Walks?.map((w, k) =>
                <Fragment key={k}>
                    <WalkSlot walk={w} onClick={(walkId) => this.onPlannedItemClicked(walkId)} />
                </Fragment>
            )}
        </Card>

        const unmatchedRequestsCard = <Card>
            <h1>Unmatched requests</h1>
            {plan?.UnmatchedRequests?.length === 0
                ? <h4>All requests have been met!</h4>
                : null}

            {plan?.UnmatchedRequests?.map((u, k) =>
                <Fragment key={k}>

                    <ArcaLink
                        text={`${u.ActivityType} (${u.Session}) ${u.Pet.FullName} - ${u.Pet.OwnerName}`}
                        width={width}
                        onClick={this.assignUnmatchedRequest.bind(this, u)}
                    />
                </Fragment>
            )}
        </Card>

        const holidaysCard = <Card>
            <h1>Walker holidays</h1>
            {plan?.WalkerHolidays.length === 0
                ? <h4>None requested</h4>
                : null}
            {plan?.WalkerHolidays?.map((p, k) =>
                <Badge key={k} className='planningbadge'>
                    <h3 >{`${p.Session} : ${p.Walker.FirstName} ${p.Walker.LastName}`}</h3>
                </Badge>
            )}
        </Card>

        ArcaHttpSystem.Log(`Width= ${ArcaHttpSystem.WindowWidth}`)

        return (

            <Fragment>
                <h1>{plan?.Date?.DayAndMonthPretty}</h1>
                {isError
                    ? <StatusBar message={statusText} isError={isError} />
                    : null}
                <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
                    <Container>

                        {windowWidth < 1024
                            ? <Fragment>
                                <Row>
                                    <Col>
                                        {plannedCard}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {unmatchedRequestsCard}
                                    </Col>
                                </Row>
                            </Fragment>
                            : <Row>
                                <Col>
                                    {plannedCard}
                                </Col>
                                <Col>
                                    {unmatchedRequestsCard}
                                </Col>
                            </Row>}
                        <Row>
                            <Col>
                                {holidaysCard}
                            </Col>
                        </Row>
                    </Container>
                </div>

                {this.state.showAssignPopup
                    ? <Modal isOpen={true} className="">
                        <ModalHeader
                            toggle={this.onCancel.bind(this)}>
                            {'Assign the pet to a group'}
                        </ModalHeader>

                        <ModalBody>
                            <p>Unfortunately <strong><q>{unmatchedRequest.Pet.FullName}</q></strong> has not been assigned to a group
                               for <strong><q>{unmatchedRequest.ActivityType} {unmatchedRequest.Session}</q></strong>. Your options are below.</p>

                            {groups
                                ? <Fragment>
                                    <h6>Use and alternative for the day</h6>
                                    {groups.filter(x =>
                                        this.sessionsMatch(x.Session, unmatchedRequest?.Session)
                                        && this.activityMatch(x.ActivityType, unmatchedRequest?.ActivityType)
                                        && !x.IsFull)
                                        .map((g, k) =>
                                            <Fragment key={k}>
                                                <ArcaLink
                                                    text={` #${g.Id} - ${g.ActivityType} - ${g.Session}:   ${g.Walker.FirstName} ${g.Walker.LastName}`}
                                                    width={width}
                                                    onClick={this.userAlternativeGroup.bind(this, unmatchedRequest, g)}
                                                />
                                            </Fragment>
                                        )}
                                </Fragment>
                                : null}

                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" checked={this.state.showAlternatives} onChange={() => this.setState({ showAlternatives: !this.state.showAlternatives })} />{' '}Show all alternatives
                                </Label>
                            </FormGroup>
                            <hr />

                            {matchedGroups && matchedGroups.length > 0
                                ? <Fragment>
                                    <h6>Assign your pet to this group permanately</h6>
                                    {matchedGroups.filter(x => !x.IsFull).map((g, k) =>
                                        <Fragment key={k}>
                                            <ArcaLink
                                                text={` #${g.Id} ${g.ActivityType} - ${g.Session}:   ${g.Walker.FirstName} ${g.Walker.LastName}`}
                                                width={width}
                                                onClick={this.assignPetToGroup.bind(this, unmatchedRequest, g)}
                                            />
                                        </Fragment>
                                    )}
                                </Fragment>
                                : null}

                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.onCancel.bind(this)}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                    : null}
            </Fragment>
        );
    }

    activityMatch(activity, unmatchedActivity) {
        var activityName = activity.split(' ')[0];
        var unmatchedActivityName = unmatchedActivity.split(' ')[0];

        return activityName === unmatchedActivityName;
    }


    // TODO: Move to it's own class
    sessionsMatch(groupSession, unmatchedRequestSession) {

        if (this.state.showAlternatives) return true;

        switch (unmatchedRequestSession) {

            case 'AM/MID':
                return (groupSession === 'AM' || groupSession === 'Mid')

            case 'P/M':
                return (groupSession === 'PM' || groupSession === 'Mid')

            default:
                return (groupSession === unmatchedRequestSession)
        }
    }

    async onPlannedItemClicked(petPlannedWalkId) {
        await ArcaHttpWalkplan.RemoveItemAsync(
            petPlannedWalkId,
            (() => this.props.needsRefresh()),
            ((err) => this.setState({ isError: true, statusText: err }))
        )
    }

    async userAlternativeGroup(unmatchedRequest, group) {

        var plan = new ArcaPlan(
            unmatchedRequest.Pet.Id,
            group.Walker.Id,
            unmatchedRequest.Pet.OwnerId,
            unmatchedRequest.Id,
            group.Session,
            group.ActivityType,
            unmatchedRequest.Date,
            true,
            unmatchedRequest.Pet.Notes,
            group.Id)

        ArcaHttpSystem.Log(`Saving plan`)

        await ArcaHttpWalkplan.SavePlan(
            plan,
            (() => this.saveSucceeded()),
            ((err) => this.setState({
                isError: true,
                statusText: err,
                showAssignPopup: false
            }))
        )
    }

    saveSucceeded() {
        this.props.needsRefresh()
        this.setState({ showAssignPopup: false })
    }

    async assignPetToGroup(unmatchedRequest, group) {

        await this.userAlternativeGroup(unmatchedRequest, group)

        await ArcaHttpClientGroup.AddPetToGroup(
            unmatchedRequest.Pet,
            group,
            (() => this.setState({
                isError: false,
                statusText: 'Item has been added to group for future planning',
                showAssignPopup: false
            })),
            ((err) => this.setState({
                isError: true,
                statusText: err,
                showAssignPopup: false
            }))
        )
    }

    onCancel() {
        this.setState({ showAssignPopup: false })
    }

    assignUnmatchedRequest(unmatchedRequest) {
        this.setState({
            showAssignPopup: true,
            unmatchedRequest
        })
    }
}